import React from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

type RenderProps = {
  attributes: DraggableAttributes
  listeners: DraggableSyntheticListeners
  isDragging: boolean
}

type Props = {
  id: string
  disabled?: boolean
  // False for a row outside its `SortableContext`'s `items` — `DashboardCustomizeBar`'s hidden rows.
  sortable?: boolean
  sx?: SxProps<Theme>
  children: (props: RenderProps) => React.ReactNode
}

const SortableRow = ({ id, disabled, sortable = true, sx, children }: Props) => {
  const { setNodeRef, transform, transition, attributes, listeners, isDragging } = useSortable({ id, disabled })

  return (
    <Box
      ref={sortable ? setNodeRef : undefined}
      // A DOM `style`, not `sx`: emotion would inject a fresh class per pointer move.
      style={{ transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.6 : 1 }}
      sx={sx}
    >
      {children({ attributes, listeners, isDragging })}
    </Box>
  )
}

export default SortableRow
